import { Fragment, useContext, useState } from "react"; 
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import { Link, useNavigate } from "react-router-dom";
import TokenService from "../../../Services/Token.service";
import { Dropdown } from "react-bootstrap";
import AdminListTable from "../AdministrativeSettings/AdminListTable";
import RequestorListTable from "../AdministrativeSettings/RequestorManagement/RequestorListTable";
import DonorListTable from "./DonorListTable";
import ClearFilterButton from "../../../Components/ClearFilterButton";
import ExportCSVButton from "../../../Components/ExportCSVButton";
import { Helmet } from "react-helmet";
 

function DonorManagement(){
  const navigate = useNavigate();
  const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);

  const [isClearFilter, setIsClearFilter] = useState(false);
  const [filterCount, setFilterCount] = useState(0); 
  const [exportCsv, setexportCsv] = useState(false);
  const handleClearFilters = () => {
      setIsClearFilter(true);
      setTimeout(() => setIsClearFilter(false), 0);
  };

  
  const handleFilterCountChange = (count) => {
    setFilterCount(count); // Update filter count
};

  const handleExportCSV = () => {
      setexportCsv(true);
      setTimeout(() => setexportCsv(false), 0);
  } 
  const previousUrl = TokenService.getPrevLink();
  return (
    <Fragment> 
          <Helmet>
            <title>DonorX | Donor Management</title>
        </Helmet>
    <div className="el-middle-wrapper">
        <h2 className="el-title">Donor Management</h2>
        <Link className="back-link" to={`/admin/administrative-settings`}><i className='el-icon-back'></i> Administrator Settings</Link>
         
        <div className="el-bg-table">
            <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-between align-items-center" > 
                    {/* style={{ width: "45%" }} */}
                    <div style={{marginRight:'15px'}}>
                        <h3>Donor List</h3>
                    </div> 
                    <ExportCSVButton handleExportCSV = {handleExportCSV}/>
                    {filterCount > 0 && ( <ClearFilterButton handleClearFilters={handleClearFilters} /> )}
                    {filterCount > 0 &&( <span className="m-2">Filters applied: {filterCount}</span> )}
                </div> 
            </div>
            <>   
                <DonorListTable isClearFilter={isClearFilter}  onFilterCountChange={handleFilterCountChange}  exportCsv={exportCsv} />
            </>
        </div>
    </div>
 
</Fragment>
  ); 
}

export default DonorManagement;